import { useEffect, useState } from "react";
import React from "react";
import { Tooltip } from "reactstrap";
import './setting.css'
import { useHistory } from "react-router-dom";
import UploadFile from "./uploadCsvFile";
import NasDrive from "./ManageMedia/NasDrive";
import httpService from "../../services/http.service";
import Email from "./ManageMedia/email/email";
import SubcriptionRenew from "./SubcriptionRenew";
import WarningMessage from "../common/warnMsg";
import ErrorMessage from "../common/errorMsg";
import SuccessMessage from "../common/successMsg";

let CloudSettings = (props) => {
    const history = useHistory();
    const [settingTab, setSettingTab] = useState(1)
    const userRole = localStorage.getItem("CloudUserType")
    const [nas_space, setNas_space] = useState(0)
    const [nasLicenceDate, setNasLicenceDate] = useState(false)
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const toggle = () => setTooltipOpen(!tooltipOpen);
    const [email, setEmail] = useState(false)
    const [nasSub, setNasSub] = useState({})
    const BucketUser = localStorage.getItem("UserId")
    const hashParams = new URLSearchParams(window.location.hash.split('?')[1]);
    const source = hashParams.get('source');
    const [tabSelection, setTabSelection] = useState(source === "renewal" ? "subscription" : "file_manager")

    function isCurrentDateBetween(startDate, endDate) {
        const currentDate = new Date(); // Get the current date

        // Convert input dates to Date objects if they aren't already
        const start = new Date(startDate);
        const end = new Date(endDate);

        // Check if the current date is between or equal to the start and end dates
        if (currentDate >= start && currentDate <= end) {

            return true;
        } else {


            return false;
        }
    }

    async function getUsersNASInfo() {
        try {
            const res = await httpService.get(`/check-gcp-storage?userId=${BucketUser}`);
            if (res.data) {
                setNas_space(res.data.user.nasSpace);
                setNasLicenceDate(isCurrentDateBetween(res.data.user.startDateNas, res.data.user.endDateNas))
            }
        } catch (err) {
            console.log({ err });
        }
    }

    console.log(nasLicenceDate, "nasLicenceDate")
    async function getNASSubInfo() {
        try {
            const res = await httpService.getByBoj(`/nassubinfo`, { userID: localStorage.getItem("UserId"), customerId: localStorage.getItem("customerId") });
            console.log(res.data, "nassubinfo");
            if (res?.data?.data) {
                setNasSub(res?.data?.data)
                console.log(res.data.data, "nassubinfo");

                setNas_space(res.data.data[0].limt);
                setNasLicenceDate(isCurrentDateBetween(res.data.data[0].startnasdate, res.data.data[0].endnasdate))
            } else {
                setNasSub({})

            }
        } catch (err) {
            console.log({ err });
        }
    }
    useEffect(() => {
        getUsersNASInfo();
        getNASSubInfo()
    }, [])


    const colorEndDay = () => {
        const currentDate = new Date();
        const endDate = new Date(nasSub.endDateNas);
        const timeDiff = endDate - currentDate;
        const daysRemaining = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

        if (daysRemaining <= 0) {
            // Interpolate color between light red and dark red as days decrease
            const redIntensity = Math.min(225, 225 - ((11 - daysRemaining) * 20));
            console.log(redIntensity)
            return false

        }
        return true
    }

    useEffect(() => {
        const customerID = localStorage.getItem("customerId");
        const type = localStorage.getItem("CloudUserType");
        if (customerID === 'Admin' || type === "admin") {
            history.push("/admindashboard");
        }
    }, [])

    return (<>
        <div className="form-boxdiv1">
            <div className="form-boxtopline6">
                <div onClick={() => history.push("/clouddashboard")}>
                    <button className="back-btn"><i class="fa fa-chevron-left" aria-hidden="true"></i></button>
                </div>
                <div className="btn21x" id="DisabledAutoHideExample1">
                    {/* <button key="uploadfile" value="value" className={"btn " + (!settingTab ? "btn3" : "btn2")} onClick={(e) => setSettingTab(0)}>
                        <i class="fa fa-file mr-2"></i>    Upload File</button> */}
                    {nas_space == '0' || (!nasLicenceDate) ?
                        <span id="DisabledAutoHideExample">
                            <button className={"btn " + (!settingTab ? "btn2" : "btn3")} onClick={(e) => {
                                setEmail(true)
                                setSettingTab(1)
                                setTabSelection("file_manager")
                            }}>
                                <i className="fa fa-server mr-2"> </i>   Manage Media</button>
                        </span> :
                        <span id="DisabledAutoHideExample">
                            <button disabled={nas_space == '0' || (!nasLicenceDate)} className={"btn " + (!settingTab ? "btn2" : "btn3")} onClick={(e) => {
                                setSettingTab(1)
                                setTabSelection("file_manager")
                            }}>
                                <i className="fa fa-server mr-2"> </i>   Manage Media</button>
                        </span>
                    }
                    {(nas_space == '0' || (!nasLicenceDate)) && <Tooltip
                        placement="top"
                        isOpen={tooltipOpen}
                        autohide={false}
                        target="DisabledAutoHideExample"
                        toggle={toggle}
                    >
                        You do not have access of RCC Cloud. Please contact Rccfiber.com!
                    </Tooltip>}
                    {userRole !== "property_user" && <button className="btn" style={{ backgroundColor: "crimson", color: "white" }} onClick={() => setTabSelection("subscription")}>
                        Your subscription
                    </button>}

                    <button className="btn" style={{ backgroundColor: "#8A784E", color: "white", marginLeft: 5 }} onClick={() => setTabSelection("change_password")}>
                        Change Password
                    </button>
                </div>
            </div>
            {/* {tabSelection === "subscription" ? (
                <SubcriptionRenew />
            ) : (
                !settingTab ? (
                    <UploadFile props={props} />
                ) : (
                    (nasSub.nasSpace && !(nasSub.nasSpace > 0)) || !colorEndDay() ? (
                        <Email reloadsub={getNASSubInfo} />
                    ) : (
                        <NasDrive
                            spaceLimit={nas_space}
                            reloadsub={getNASSubInfo}
                            nassubdata={nasSub}
                        />
                    )
                )
            )} */}

            {tabSelection === "subscription" && <SubcriptionRenew />}
            {tabSelection === "file_manager" && (
                !settingTab ? (
                    <UploadFile props={props} />
                ) : (
                    (!nasSub.nasSpace || nasSub.nasSpace <= 0 || !colorEndDay()) ? (
                        <Email reloadsub={getNASSubInfo} />
                    ) : (
                        <NasDrive
                            spaceLimit={nas_space}
                            reloadsub={getNASSubInfo}
                            nassubdata={nasSub}
                        />
                    )
                )
            )}
            {tabSelection === "change_password" && <ChangePassword />}
        </div>
    </>
    )
}

export default CloudSettings;

const ChangePassword = () => {
    const [form, setForm] = useState({
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
    });

    const [loading, setLoading] = useState(false)

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const resetState = () => {
        setForm({
            oldPassword: "",
            newPassword: "",
            confirmPassword: ""
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        try {
            const { oldPassword, newPassword, confirmPassword } = form;
            const userId = localStorage.getItem("UserId")

            if (newPassword !== confirmPassword) {
                WarningMessage("Password is not matching please re-enter.")
                return;
            }
            let { data } = await httpService.CreateUpdate("password-update", { userId, oldPassword, password: newPassword })
            if (data.ack === "0") {
                return WarningMessage(data.message)
            }
            SuccessMessage(data.message)
            resetState()
        } catch (error) {
            ErrorMessage("Something went wrong")
        } finally {
            setLoading(false)
        }



    };


    return (
        <div>
            <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 10 }} >
                <div>
                    <div>Old Password</div>
                    <input
                        type="password"
                        name="oldPassword"
                        placeholder="Old Password"
                        value={form.oldPassword}
                        onChange={handleChange}
                        style={{ outline: "none", border: "1px solid #B2D8CE", width: 430, padding: 10, borderRadius: 6 }}
                    />
                </div>
                <div>
                    <div>New Password</div>
                    <input
                        type="password"
                        name="newPassword"
                        placeholder="New Password"
                        value={form.newPassword}
                        onChange={handleChange}
                        style={{ outline: "none", padding: 10, border: "1px solid #B2D8CE", width: 430, borderRadius: 6 }}
                    />
                </div>
                <div>
                    <div>Confirm Password</div>
                    <input
                        type="password"
                        name="confirmPassword"
                        placeholder="Confirm Password"
                        value={form.confirmPassword}
                        onChange={handleChange}
                        style={{ outline: "none", padding: 10, border: "1px solid #B2D8CE", width: 430, borderRadius: 6 }}
                    />
                </div>
                <button
                    type="submit"
                    disabled={
                        loading || !(form.oldPassword && form.newPassword && form.confirmPassword)
                    }
                    style={{
                        width: 430,
                        border: "none",
                        padding: 10,
                        backgroundColor:
                            form.oldPassword && form.newPassword && form.confirmPassword && !loading
                                ? "#002c42"
                                : "rgb(88, 113, 125)",
                        color: "white",
                        borderRadius: 6,
                    }}
                >
                    {loading ? "Wait..." : "Update Password"}
                </button>
            </form>
        </div>
    );
};